
import type { PropType } from 'vue'
import { computed, defineComponent, getCurrentInstance, ref } from 'vue'
import { useCopyToClipboard } from '../../composables/use-copy-to-clipboard'
import { ColorEnum } from '../../enums/color.enum'

export default defineComponent({
  name: 'CopyToClipboard',
  props: {
    value: String,
    display: {
      type: Boolean,
      default: undefined,
    },
    color: {
      type: String as PropType<ColorEnum>,
      required: false,
      default: () => ColorEnum.NEUTRAL_90,
    },
  },
  setup(props, ctx) {
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const baseClass = 'epb-copy-to-clipboard'
    const copied = ref(false)
    const hovered = ref(false)
    const messages = $epb.messages
    const contentWrapper = ref<HTMLElement>(null)

    const { copyToClipboardIcon, copyToClipboard } = useCopyToClipboard()

    const isCopyIconDisplayed = computed(() => {
      return props.display ?? hovered.value
    })

    async function copyContent() {
      try {
        await copyToClipboard(props.value ?? contentWrapper.value.innerText)
      } catch (e) {
        ctx.emit('showError', messages.errors.default.message)
      }
    }

    return {
      baseClass,
      copied,
      hovered,
      messages,
      contentWrapper,
      isCopyIconDisplayed,
      copyContent,
      copyToClipboardIcon,
    }
  },
})
